module.exports = __webpack_public_path__ + "static/media/Icon-Notification-Grey.2a0f2109.svg";